<template>
  <div>
    <div class="hide-on-print">

      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Produtos Preferenciais"
      >
      </page-title>

      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12 mb-3">
            <base-input
              class="mb-3"
              v-model="filter.code"
              placeholder="Ex: 0000083"
              label="Código"
            >
            </base-input>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <base-input
              class="mb-3"
              v-model="filter.name"
              placeholder="Ex: BELT"
              label="Nome"
            >
            </base-input>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <base-input
              class="mb-3"
              v-model="filter.brand"
              placeholder="Ex: BAYER"
              label="Marca"
            >
            </base-input>
          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <label class="form-control-label"> Produto </label>
            <multiselect
              v-model="filter.product"
              :options="products"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder=""
              label="description"
              track-by="id"
              @input="filterPreferredproducts()"
              @search-change="getProducts"
            />
          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <label class="form-control-label">Produto Preferencial </label>
            <multiselect
              required="true"
              v-model="filter.preferredproduct"
              :options="filteredPreferredproducts"
              placeholder=""
              label="name"
              track-by="id"
              @search-change="filterPreferredproducts"
            />
            <div
              v-if="this.filter.product && !this.filter.preferredproduct"
                class="invalid-feedback"
                style="display: block;"
              >
                * Campo obrigatório
              </div>
          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <label class="form-control-label">Grupo</label>
            <multiselect
              v-model="filter.grupo"
              :options="grupos"
              placeholder="Selecionar Grupo"
              label="descricao"
              track-by="id"
            />
          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <label class="form-control-label">Subgrupo</label>
            <multiselect
              v-model="filter.subgrupo"
              :options="subgrupos"
              label="descricao"
              placeholder="Selecionar Subgrupo"
              track-by="id"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="downloadPdf"
            >Gerar PDF</base-button
          >
          <base-button type="secondary" class="mt-2" @click="exportToExcel()"
            >Gerar Excel</base-button
          >
          <base-button
            type="primary"
            class="mt-2 ml-2"
            @click="generateReport"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card v-show="preferredproducts && preferredproducts.length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Produtos Preferenciais - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width:200px;
            display:block;
            margin-left:auto;
            margin-right:auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Produtos Preferenciais - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.code">
          code: {{ filter.code }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.name">
          name: {{ filter.name }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.brand">
          brand: {{ filter.brand }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.grupo && Object.keys(filter.grupo).length"
        >
          Grupo: {{ filter.grupo.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.subgrupo && Object.keys(filter.subgrupo).length"
        >
          Subgrupo: {{ filter.subgrupo.descricao }}
        </h6>
        <br />
        <br />
        <br />
      </div>

      <div
        v-for="preferredproduct in preferredproducts"
        :key="preferredproduct && preferredproduct.id"
      >
        <h5 class="h3 mb-0">{{ preferredproduct.name }}</h5>
        <card id="tableId">
          <el-table
            v-if="preferredproduct && preferredproduct.products && preferredproduct.products.length > 0"
            min-width="500px"
            :data="preferredproduct.products"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
          >
            <el-table-column class="h3 mb-0" :label="preferredproduct.name">
              <el-table-column label="Código" width="165px" prop="code" />
              <el-table-column label="Nome" width="225px" prop="description" />
              <el-table-column label="Marca" width="195px" prop="brand" />
              <el-table-column label="Grupo" width="195px" prop="grupo" />
              <el-table-column label="Subgrupo" width="195px" prop="subgrupo" />
              <el-table-column label="Unidade" width="155px" prop="unity" />
            </el-table-column>
          </el-table>
        </card>
        <br />
        <br />
        <br />
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { Table, TableColumn } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      filter: {
        grupo: {},
        subgrupo: {},
      },
      grupos: [],
      subgrupos: [],
      product: [],
      products: [],
      filteredPreferredproducts: [],
      preferredproducts: [],
      lastEdition: new Date(),
      isLoading: false,
    };
  },
  methods: {
    async downloadPdf() {
      this.isLoadingPdfDownload = true;

      try {
        const response = await this.$http.secured.get("/api/v1/preferredproducts.pdf", { 
          params: {
            send_pdf: true,
            grupo_id: this.filter.grupo ? this.filter.grupo.id : null,
            subgrupo_id: this.filter.subgrupo ? this.filter.subgrupo.id : null,
            code: this.filter.code ? this.filter.code : null,
            name: this.filter.name || (this.filter.preferredproduct ? this.filter.preferredproduct.name : null),
            brand: this.filter.brand 
          }, 
          responseType: "arraybuffer"
        })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `Produto Preferencial.pdf`
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      }
      this.isLoadingPdfDownload = false;
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    clearFilters() {
      this.filter.code = "",
      this.filter.name = "",
      this.filter.brand = "",
      this.filter.product = [],
      this.filter.preferredproduct = "",
      this.filter.grupo = {},
      this.filter.subgrupo = {}
    },
    async getProducts(query) {
      this.$http.secured;
      try {
        const response = await this.$http.secured.get("/api/v1/products", {
          params: {
            per_page: 10,
            q: { description: query },
          },
        });
        this.products = response.data.products;
      } catch (error) {}
    },
    async getPreferred(query) {
      try {
        const response = await this.$http.secured.get(
          "/api/v1/preferredproducts",
          {
            params: {
              per_page: 20,
              q: { name: query },
            },
          }
        );
        this.preferredproducts = response.data.preferredproducts;
      } catch (error) {}
    },
    async filterPreferredproducts(query = null) {
      try {
        const params = { q: {} }

        if (query) params.q.name = query
        if (this.filter.product && this.filter.product.id) params.q.product_id = this.filter.product.id
        
        const response = await this.$http.secured.get(
          "/api/v1/preferredproducts",
          { params: params }
        );
        this.filteredPreferredproducts = response.data.preferredproducts;
        console.log("")
      } catch (error) {}
    },
    generateReport() {
      this.isLoading = true;

       if (this.filter.product && !this.filter.preferredproduct) {
        this.isLoading = false;
        this.$toasted.global.defaultError({msg: 'Favor preencher campos obrigatórios!'});
        return false;
      }
      this.$http.secured
        .get("/api/v1/report/preferredproducts", {
          params: {
            grupo_id: this.filter.grupo? this.filter.grupo.id : null,
            subgrupo_id: this.filter.subgrupo ? this.filter.subgrupo.id : null,
            "products[goal]": this.filter.code ? this.filter.code.id : null,
            name: this.filter.name || (this.filter.preferredproduct ? this.filter.preferredproduct.name : null),
            brand: this.filter.brand
          },
        })
        .then((response) => {
          this.lastEdition = new Date();
          this.preferredproducts = response.data;
          this.isLoading = false;
        })
        .catch((_e) => {
          this.isLoading = false;
        });
    },
    initGrupos() {
      this.$http.secured
        .get("/api/v1/grupos")
        .then((response) => (this.grupos = response.data));
    },
    initSubgrupos() {
      this.$http.secured
        .get("/api/v1/subgrupos")
        .then((response) => (this.subgrupos = response.data));
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.initGrupos();
    this.initSubgrupos();
    this.getProducts("");
    this.filterPreferredproducts();
  },
};
</script>
<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
